/**
 * Sanitização de inputs — barreira contra XSS e injeção de scripts.
 *
 * Deve ser chamado ANTES de enviar qualquer texto livre pro backend.
 * Remove tags HTML/script, limpa caracteres perigosos e limita tamanho.
 */

// Remove qualquer coisa que pareça uma tag HTML: <script>, <img onerror=...>, etc.
const STRIP_TAGS = /<[^>]*>/g;

// Caracteres que não fazem sentido em nomes de categoria, produto, etc.
const DANGEROUS_CHARS = /[<>"'`;(){}]/g;

/**
 * Limpa um texto livre removendo tags e caracteres perigosos.
 * @param {string} value - texto digitado pelo usuário
 * @param {number} maxLength - tamanho máximo permitido (default 200)
 * @returns {string} texto limpo
 */
export const sanitizeText = (value, maxLength = 200) => {
  if (!value || typeof value !== 'string') return '';

  return value
    .replace(STRIP_TAGS, '')       // remove tags HTML
    .replace(DANGEROUS_CHARS, '')  // remove caracteres perigosos
    .substring(0, maxLength)       // limita tamanho
    .trim();
};

/**
 * Valida se um texto contém conteúdo suspeito (pra mostrar erro no form).
 * @param {string} value
 * @returns {{ valid: boolean, message?: string }}
 */
export const validateTextInput = (value) => {
  if (!value) return { valid: true };

  if (STRIP_TAGS.test(value)) {
    return { valid: false, message: 'O texto não pode conter tags HTML.' };
  }

  if (/javascript:/i.test(value) || /on\w+\s*=/i.test(value)) {
    return { valid: false, message: 'O texto contém conteúdo não permitido.' };
  }

  return { valid: true };
};
